import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationPeriodActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/AccountPeriod/AccountPeriodBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationPeriod"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationPeriod"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationPeriodActivity)
